import { ExportOutlined } from "@ant-design/icons";
import { Typography, theme } from "antd";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { isInternalPath } from "../InternalLink";

export const CustomTextField = ({
  value = "",
  prefix,
  copyable = false,
  onEmpty = "n/a",
  link = "",
  newPage = false,
  style,
}: {
  value?: string | String | null | number;
  prefix?: any;
  copyable?: boolean;
  onEmpty?: "none" | "n/a";
  link?: string;
  newPage?: boolean;
  style?: React.CSSProperties;
}) => {
  const { token } = theme.useToken();

  const displayValue = value ? (
    value
  ) : (
    <Typography.Text type="secondary">{onEmpty}</Typography.Text>
  );

  const linkStyle: React.CSSProperties = {
    color: token.colorLink,
    ...style,
  };

  return (
    <div style={{ display: "flex" }}>
      {link && !newPage ? (
        isInternalPath(link) ? (
          <RouterLink to={link} style={linkStyle}>
            {prefix} {displayValue}
          </RouterLink>
        ) : (
          <Typography.Link href={link} style={style}>
            {prefix} {displayValue}
          </Typography.Link>
        )
      ) : (
        <Typography.Text style={style}>
          {prefix} {displayValue}
        </Typography.Text>
      )}
      {copyable && (
        <Typography.Text copyable={{ text: (value || "").toString() }} />
      )}{" "}
      {link && newPage && (
        <RouterLink to={link} target="_blank" rel="noopener noreferrer">
          {" "}
          <ExportOutlined />
        </RouterLink>
      )}
    </div>
  );
};
